import {
  EmptyState,
  Section,
  TitleAndDescription,
  UpgradingIllustration,
} from '@ferreri/prever-component-lib';
import { useWhatsappApi } from 'utils/useWhatsappApi';

export const PetAssistanceBenefitEmptyState = () => {
  const { handleSendWhatsappMessage } = useWhatsappApi({
    phone: '+551132882526',
    text: 'Olá, gostaria de informações sobre upgrade de plano para ter direito a Assistência Pet.',
  });

  return (
    <Section>
      <TitleAndDescription
        title="Plano sem benefício"
        description="Este benefício é exclusivo do plano Multiassistência."
      />
      <EmptyState
        illustration={<UpgradingIllustration />}
        description="Entre em contato com a central de atendimento para fazer o upgrade do seu plano."
        buttonLabelPrimary="Entrar em contato pelo Whatsapp"
        onClickButtonPrimary={handleSendWhatsappMessage}
      />
    </Section>
  );
};
